export default __webpack_public_path__ + "static/logo_msg-ae410148b9dc616115e50c5f47713976.svg";